import { TimesheetStatus } from '@sdk/timesheets/api/apiTypes';
import StatusLabel from '@sdk/components/ui/StatusLabel';

import { useStatusLabelAndType } from '@web/timesheets/TimesheetStatusLabel/timesheetStatusLabel.hooks';
import { NonStrechingDiv } from '@web/timesheets/TimesheetStatusLabel/timesheetStatusLabel.styles';

type Props = {
  status: TimesheetStatus;
  isAssignee: boolean;
  isManager: boolean;
};
const TimesheetStatusLabel = ({ status, isAssignee, isManager }: Props) => {
  const { label, type } = useStatusLabelAndType(status, isAssignee, isManager);

  return (
    <NonStrechingDiv>{label ? <StatusLabel label={label} type={type} /> : ''}</NonStrechingDiv>
  );
};

export default TimesheetStatusLabel;
